import _defineProperty from "/home/vsts/work/1/s/packages/husky-site/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _slicedToArray from "/home/vsts/work/1/s/packages/husky-site/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _asyncToGenerator from "/home/vsts/work/1/s/packages/husky-site/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import _regeneratorRuntime from "/home/vsts/work/1/s/packages/husky-site/node_modules/@babel/runtime/regenerator/index.js";
import { setCredentialFeature } from "@aws-sdk/core/client";
import { doesIdentityRequireRefresh, isIdentityExpired, memoizeIdentityProvider, normalizeProvider } from "@smithy/core";
import { SignatureV4 } from "@smithy/signature-v4";
export var resolveAwsSdkSigV4Config = function resolveAwsSdkSigV4Config(config) {
  var isUserSupplied = false;
  var credentialsProvider;
  if (config.credentials) {
    isUserSupplied = true;
    credentialsProvider = memoizeIdentityProvider(config.credentials, isIdentityExpired, doesIdentityRequireRefresh);
  }
  if (!credentialsProvider) {
    if (config.credentialDefaultProvider) {
      credentialsProvider = normalizeProvider(config.credentialDefaultProvider(Object.assign({}, config, {
        parentClientConfig: config
      })));
    } else {
      credentialsProvider = /*#__PURE__*/function () {
        var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
          return _regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  throw new Error("`credentials` is missing");
                case 1:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee);
        }));
        return function credentialsProvider() {
          return _ref.apply(this, arguments);
        };
      }();
    }
  }
  var boundCredentialsProvider = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              return _context2.abrupt("return", credentialsProvider({
                callerClientConfig: config
              }));
            case 1:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));
    return function boundCredentialsProvider() {
      return _ref2.apply(this, arguments);
    };
  }();
  var _config$signingEscape = config.signingEscapePath,
    signingEscapePath = _config$signingEscape === void 0 ? true : _config$signingEscape,
    _config$systemClockOf = config.systemClockOffset,
    systemClockOffset = _config$systemClockOf === void 0 ? config.systemClockOffset || 0 : _config$systemClockOf,
    sha256 = config.sha256;
  var signer;
  if (config.signer) {
    signer = normalizeProvider(config.signer);
  } else if (config.regionInfoProvider) {
    signer = function signer() {
      return normalizeProvider(config.region)().then( /*#__PURE__*/function () {
        var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(region) {
          return _regeneratorRuntime.wrap(function _callee3$(_context3) {
            while (1) {
              switch (_context3.prev = _context3.next) {
                case 0:
                  _context3.t1 = config;
                  _context3.t2 = region;
                  _context3.next = 4;
                  return config.useFipsEndpoint();
                case 4:
                  _context3.t3 = _context3.sent;
                  _context3.next = 7;
                  return config.useDualstackEndpoint();
                case 7:
                  _context3.t4 = _context3.sent;
                  _context3.t5 = {
                    useFipsEndpoint: _context3.t3,
                    useDualstackEndpoint: _context3.t4
                  };
                  _context3.next = 11;
                  return _context3.t1.regionInfoProvider.call(_context3.t1, _context3.t2, _context3.t5);
                case 11:
                  _context3.t0 = _context3.sent;
                  if (_context3.t0) {
                    _context3.next = 14;
                    break;
                  }
                  _context3.t0 = {};
                case 14:
                  _context3.t6 = _context3.t0;
                  _context3.t7 = region;
                  return _context3.abrupt("return", [_context3.t6, _context3.t7]);
                case 17:
                case "end":
                  return _context3.stop();
              }
            }
          }, _callee3);
        }));
        return function (_x) {
          return _ref3.apply(this, arguments);
        };
      }()).then(function (_ref4) {
        var _ref5 = _slicedToArray(_ref4, 2),
          regionInfo = _ref5[0],
          region = _ref5[1];
        var signingRegion = regionInfo.signingRegion,
          signingService = regionInfo.signingService;
        config.signingRegion = config.signingRegion || signingRegion || region;
        config.signingName = config.signingName || signingService || config.serviceId;
        var params = _objectSpread(_objectSpread({}, config), {}, {
          credentials: boundCredentialsProvider,
          region: config.signingRegion,
          service: config.signingName,
          sha256: sha256,
          uriEscapePath: signingEscapePath
        });
        var SignerCtor = config.signerConstructor || SignatureV4;
        return new SignerCtor(params);
      });
    };
  } else {
    signer = /*#__PURE__*/function () {
      var _ref6 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(authScheme) {
        var signingRegion, signingService, params, SignerCtor;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.t0 = Object;
                _context4.t1 = {};
                _context4.t2 = config.signingName || config.defaultSigningName;
                _context4.next = 5;
                return normalizeProvider(config.region)();
              case 5:
                _context4.t3 = _context4.sent;
                _context4.t4 = {};
                _context4.t5 = {
                  name: "sigv4",
                  signingName: _context4.t2,
                  signingRegion: _context4.t3,
                  properties: _context4.t4
                };
                _context4.t6 = authScheme;
                authScheme = _context4.t0.assign.call(_context4.t0, _context4.t1, _context4.t5, _context4.t6);
                signingRegion = authScheme.signingRegion;
                signingService = authScheme.signingName;
                config.signingRegion = config.signingRegion || signingRegion;
                config.signingName = config.signingName || signingService || config.serviceId;
                params = _objectSpread(_objectSpread({}, config), {}, {
                  credentials: boundCredentialsProvider,
                  region: config.signingRegion,
                  service: config.signingName,
                  sha256: sha256,
                  uriEscapePath: signingEscapePath
                });
                SignerCtor = config.signerConstructor || SignatureV4;
                return _context4.abrupt("return", new SignerCtor(params));
              case 17:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }));
      return function signer(_x2) {
        return _ref6.apply(this, arguments);
      };
    }();
  }
  return _objectSpread(_objectSpread({}, config), {}, {
    systemClockOffset: systemClockOffset,
    signingEscapePath: signingEscapePath,
    credentials: isUserSupplied ? /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5() {
      return _regeneratorRuntime.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              return _context5.abrupt("return", boundCredentialsProvider().then(function (creds) {
                return setCredentialFeature(creds, "CREDENTIALS_CODE", "e");
              }));
            case 1:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5);
    })) : boundCredentialsProvider,
    signer: signer
  });
};
export var resolveAWSSDKSigV4Config = resolveAwsSdkSigV4Config;